import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import announcementsPlugin from '@backstage-community/plugin-announcements/alpha';
import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import { amplitudeAnalyticsModule } from '@internal/backstage-plugin-app-module-amplitude-analytics';
import doraMetricsPlugin from '@internal/backstage-plugin-dora-metrics';
import { homeModule } from '@internal/backstage-plugin-home';
import { teamCostsModule } from '@internal/backstage-plugin-team-costs';
import { scorecardsModule } from '@internal/backstage-plugin-tech-insights-module-scorecards';
import { scmIntegrationsApi, userSettingsStorageApi } from './apis';
import { obosThemeExtension } from './extensions/obosTheme/obosThemeExtension';
import { signInPageExtension } from './extensions/signInPage/signInPageExtension';
import { navModule } from './modules/nav';
import { techDocsMermaidWithZoomModule } from './extensions/mermaidWithZoom/mermaidWithZoomExtension';

const app = createApp({
  features: [
    createFrontendModule({
      pluginId: 'app',
      extensions: [
        obosThemeExtension,
        scmIntegrationsApi,
        signInPageExtension,
        userSettingsStorageApi,
      ],
    }),
    amplitudeAnalyticsModule,
    doraMetricsPlugin,
    homeModule,
    teamCostsModule,
    navModule,
    techDocsMermaidWithZoomModule,
    announcementsPlugin,
    techInsightsPlugin,
    scorecardsModule,
  ],
});

export default app.createRoot();
